import { Controller } from "@hotwired/stimulus"

// Clears a localStorage key in response to an event. Used by the location
// search forms to drop the saved map center so a new search recenters.
//
// <form data-controller="clear-storage"
//       data-clear-storage-key-value="advocate-map.landing"
//       data-action="submit->clear-storage#clear">
export default class extends Controller {
  static values = { key: String }

  clear() {
    try {
      window.localStorage.removeItem(this.keyValue)
    } catch (e) {
      // localStorage unavailable (private mode, disabled) — nothing to clear.
    }
  }
}
